/* File : src/pages/GuestPages/RegistrationPage.js */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RegistrationForm from '../../components/guest/RegistrationForm';
import { useEvent } from '../../contexts/EventContext';
import './GuestPages.css';

/**
 * Page d'inscription à l'événement
 */
const RegistrationPage = () => {
  const navigate = useNavigate();
  const { eventDetails, loading, error, selectedCity } = useEvent();
  console.log("RegistrationPage rendering, birthYear in localStorage:", localStorage.getItem('birthYear'));
  console.log("RegistrationPage rendering, selectedCity:", selectedCity);

  // Vérifier si l'utilisateur a passé la vérification d'âge ET sélectionné une ville
  useEffect(() => {
    const birthYear = localStorage.getItem('birthYear');
    const city = localStorage.getItem('selectedCity');
    
    if (!birthYear) {
      navigate('/');
    } else if (!city) {
      navigate('/city-selection');
    }
  }, [navigate]);

  // Afficher un message de chargement pendant la récupération des détails de l'événement
  if (loading) {
    return (
      <div className="guest-page loading-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Chargement des informations de l'événement...</p>
        </div>
      </div>
    );
  }

  // Afficher un message d'erreur si la récupération des détails a échoué
  if (error || !eventDetails) {
    return (
      <div className="guest-page error-page">
        <div className="error-container">
          <h2>Erreur</h2>
          <p>{error || "Impossible de charger les détails de l'événement"}</p>
          <button 
            className="btn-primary" 
            onClick={() => navigate('/city-selection')}
          >
            Changer de ville
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="guest-page">
      <RegistrationForm />
    </div>
  );
};

export default RegistrationPage;